import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  padding-bottom: 8rem;
  min-height: calc(100vh - 200px);
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.5rem;
  font-weight: 400;
`;

const IntroText = styled.p`
  text-align: center;
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.3rem;
  line-height: 1.8;
  margin-bottom: 4rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const EventCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 3rem 2rem;
  margin: 2rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const EventName = styled.h2`
  color: #333;
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.2rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const EventDate = styled.p`
  color: #666;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
`;

const EventVenue = styled.p`
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  font-style: italic;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const Divider = styled.div`
  width: 60px;
  height: 1px;
  background: #ddd;
  margin: 0 auto 2rem auto;
`;

const Schedule = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

const ScheduleItem = styled.div`
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ScheduleTime = styled.span`
  display: block;
  color: #333;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 0.35rem;
`;

const AttireSection = styled.div`
  margin-top: 2rem;
`;

const AttireLabel = styled.span`
  display: block;
  color: #333;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 0.35rem;
`;

const AttireText = styled.p`
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin: 0;
`;

const Event = () => {
  return (
    <PageContainer className="fade-in">
      <Title>Wedding Day</Title>

      <IntroText>
        We can't wait to celebrate with you! Here are all the details for our wedding day.
      </IntroText>

      <EventCard>
        <EventName>The Wedding</EventName>
        <EventDate>Sunday, October 11, 2026</EventDate>
        <EventVenue>
          Glen Island Harbour Club
          <br />
          New Rochelle, New York
        </EventVenue>

        <Divider />

        <Schedule>
          <ScheduleItem>
            <ScheduleTime>4:30 PM</ScheduleTime>
            Cocktails &amp; Bedeken
          </ScheduleItem>
          <ScheduleItem>
            Ceremony and Reception to follow
          </ScheduleItem>
        </Schedule>

        <AttireSection>
          <Divider />
          <AttireLabel>Attire</AttireLabel>
          <AttireText>Black Tie</AttireText>
        </AttireSection>
      </EventCard>

      <EventCard>
        <EventName>After Party</EventName>
        <EventDate>10:30 – 11:30 PM</EventDate>
        <EventVenue>
          Glen Island Harbour Club
          <br />
          New Rochelle, New York
        </EventVenue>

        <Divider />

        <Schedule>
          <ScheduleItem>
            Join us for an after party immediately following the wedding.
          </ScheduleItem>
        </Schedule>
      </EventCard>
    </PageContainer>
  );
};

export default Event;
